export const muiStepperSteps = {
  createChamp: [
    {
      label: "Basics",
      description: ``,
    },
    {
      label: "Series",
      description: ``,
    },
    {
      label: "Rules & Regs",
      description: ``,
    },
    {
      label: "Badges",
      description: ``,
    },
  ],
}
